import type { RoleOption } from '../../platform/supabase/adult-data';

// What kind of account this is, from its role options. A parent account
// holds parent_carer (plus a private "home school" teacher role that powers
// parent Assign work -- that one doesn't make it a teacher). A teacher
// account holds a teacher role at a real school. An account with neither
// (brand new, or a teacher still setting up their school) is 'none'. A
// school admin (2026-10-01) holds only the school_lead role.
export type AccountKind = 'teacher' | 'parent' | 'school' | 'none';

export function accountKindOf(options: RoleOption[]): AccountKind {
  if (options.some((option) => option.role === 'parent_carer')) return 'parent';
  if (
    options.some(
      (option) =>
        option.role === 'teacher' &&
        option.schoolId !== null &&
        !option.isHomeSchool,
    )
  )
    return 'teacher';
  if (options.some((option) => option.role === 'school_lead')) return 'school';
  return 'none';
}

export function homePathFor(kind: AccountKind): string {
  if (kind === 'parent') return '/adult/parent-home';
  if (kind === 'teacher') return '/adult/teacher';
  if (kind === 'school') return '/adult/school';
  return '/adult/role-selection';
}

// Account kind per signed-in user, for the life of the page, so moving
// between pages doesn't re-ask the server every time.
export const kindCache = new Map<string, Promise<AccountKind>>();

// For tests: forget cached account kinds between cases.
export function clearAccountKindCache() {
  kindCache.clear();
}
